import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Loader from 'components/loader/loader'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import {
	getCurrentUser,
} from 'state/selectors'

import { forIn } from 'lodash'

import { Doughnut } from 'react-chartjs-2'

import { 
    formatByTimeZone,
    getBaseSlugFromPath,
    textTimeString,
    getColour
} from 'utils'

import { accentColour } from 'env'

class ProjectProgressItem extends Component {
    openProject = _ => {
        const {
            project,
            allProjects,
            projectId,
            match,
            history
        } = this.props

        const projectObject = project ? project : allProjects[projectId]
        const urlSlug = getBaseSlugFromPath(match.url)
        const newUrl = `${urlSlug}/projects/${projectObject.slug}`

        history.push(newUrl)
    }

    options = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {enabled: false},
        legend: {
            display: false,
        },
        rotation: 180,
        cutoutPercentage: 80,
        animation: {
            animateRotate: true
        }
    }

    generateDoughnutData = project => {
        const {
            userData,
            isShowingAllStatuses
        } = this.props

        let completionPercent = null

        const data = {
            datasets: [{
                label: '',
                borderWidth: 0,
                backgroundColor: [],
                data: []
            }]
        }

        const bgColour = userData.show_dark_ui ? 'rgba(255,255,255,0.2)' : '#ddd'

        completionPercent = parseInt(project.progressPercent)

        if(!completionPercent){
            completionPercent = 0.001
        }

        if(project.completionByStatus && isShowingAllStatuses){
            const {
                totalTasks,
                completionByStatus
            } = project

            let remainingTasks = totalTasks

            forIn(completionByStatus, (number, statusId) => {
                const colour = statusId == 3 ? accentColour() : getColour(parseInt(statusId))

                const percent = (number/totalTasks) * 100

                remainingTasks -= number

                if(percent){
                    data.datasets[0].backgroundColor.unshift(colour)
                    data.datasets[0].data.unshift(percent)
                }
            })

            if(remainingTasks > 0){
                const remainingTasksPercent = (remainingTasks/totalTasks) * 100

                data.datasets[0].backgroundColor.push(bgColour)
                data.datasets[0].data.push(remainingTasksPercent)
            }else if(!data.datasets[0].backgroundColor.length){
                data.datasets[0].backgroundColor.push(bgColour)
                data.datasets[0].data.push(1)
            }
        }else if(typeof project.progressPercent !== 'undefined'){
            data.datasets[0].backgroundColor = [bgColour]
            data.datasets[0].data = [(100 - completionPercent)]

            if(completionPercent){
                data.datasets[0].backgroundColor.unshift(accentColour())
                data.datasets[0].data.unshift(completionPercent)
            }
        }

        return {
            data,
            completionPercent
        }
    }

    render(){
        const { 
            projectId,
            allFolders,
            allProjects,
            isShowingTiming
        } = this.props

        let project = this.props.project

        let timeCompletionPercent = null

        // we can supply either an ID or an object.
        if(!project){
            if(projectId){
                project = allProjects[projectId]
            }

            if(!project){
                return null
            }
        }

        let timeTrackingClass = 'time-tracking-overview'

        if(project.trackedMinutes || project.estimatedMinutes){
            timeCompletionPercent = project.estimatedMinutes ? (project.trackedMinutes/project.estimatedMinutes) * 100 : 100
        }else{
            timeTrackingClass += ' hidden'
        }

        const doughnutData = this.generateDoughnutData(project)

        const showLoader = doughnutData.completionPercent === null

        const folder = allFolders[project.folder_id] ? allFolders[project.folder_id] : null

        const completionPercentString = !isNaN(doughnutData.completionPercent) ? Math.round(doughnutData.completionPercent)+'%' : '0%'

        return (
            <li className="project-progress-item" onClick={this.openProject} ref={"itemRef"}>
                <div className="meta-container">
                    <p>
                        { project.name }
                    </p>
                    { folder ?  
                        <span>
                            <Icon name="folder-o" /> 
                            { folder.name }
                        </span>
                        : null
                    }
                    <span>
                        <Icon name="fe-calendar" /> 
                        { project.end_date ? 
                            'Ends '+formatByTimeZone(project.end_date,'MMMM Do')
                            :
                            '(No end date)'
                        }
                    </span>
                </div>
                <div className={showLoader ? "doughnut-container loading" : "doughnut-container"}>
                    <span>
                        {showLoader ? 
                            <Loader visible={true} /> :
                            completionPercentString
                        }
                    </span>
                    <Doughnut 
                        data={doughnutData.data} 
                        options={this.options} 
                    />
                </div>
                { isShowingTiming ?
                <div className={timeTrackingClass}>
                    <div>
                        <label>
                            Tracked: 
                        </label>
                        <span>
                            { textTimeString(project.trackedMinutes, 'minutes', true) }
                        </span>
                    </div>
                    <div>
                        <label>
                            Estimated
                        </label>
                        <span>
                        { textTimeString(project.estimatedMinutes, 'minutes', true) }
                        </span>
                    </div>
					<div className="dateprogress-bar">
						<div style={{width: timeCompletionPercent+'%'}} />
					</div>
                </div>
                : null }
            </li>
        )
    }
}

const mapStateToProps = state => {
	return {
        allFolders: state.account.entities.folders,
        allProjects: state.account.entities.projects,
        userData: getCurrentUser(state)
	}
}

export default withRouter(connect(mapStateToProps, {})(ProjectProgressItem))


// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-project-progress-item.jsx